type LoadScriptOptions = {
  src: string;
  async?: boolean;
  defer?: boolean;
  attributes?: Record<string, string>;
};

export function loadScript({
  src,
  async = true,
  defer = false,
  attributes = {},
}: LoadScriptOptions): Promise<void> {
  return new Promise((resolve, reject) => {
    if (document.querySelector(`script[src="${src}"]`)) {
      resolve();
      return;
    }

    const script = document.createElement('script');
    script.src = src;
    script.async = async;
    script.defer = defer;

    Object.entries(attributes).forEach(([key, value]) => {
      script.setAttribute(key, value);
    });

    script.onload = () => resolve();
    script.onerror = () => reject(new Error(`Failed to load script: ${src}`));

    document.head.appendChild(script);
  });
}
